/* eslint-disable */
import { getState, setState, removeState } from "@/utils/localStore";
import { LocalStoreConstants } from "@/utils/AppConfig";
import { UPDATE_TOAST_NOTIFICATION, SET_TOAST_NOTIFICATION, SET_TOAST_NOTIFICATION_FIELD, SHOW_TOAST_NOTIFICATION } from "@/state/actions-mutations-type";

var notificationTimeoutId;
const state = {
  toastNotification: {
    isVisible: false,
    message: "",
    statusCode: 2
  }
};
const getters = {
  isVisible(state) {
    return state.toastNotification.isVisible;
  },
  toastNotification(state) {
    return state.toastNotification;
  }
};

const actions = {
  initStore({ state, dispatch }) {},
  [SHOW_TOAST_NOTIFICATION]({ state, dispatch, commit }, {message, statusCode}) {
    var data = { isVisible: true, message: message, statusCode: statusCode };
    commit("updateData", data);
    dispatch('hideToastNotification');
  },
  [UPDATE_TOAST_NOTIFICATION]({ state, commit }, data) {
    commit(SET_TOAST_NOTIFICATION, data);
  },
  hideToastNotification({ state, commit, dispatch }) {
    clearTimeout(notificationTimeoutId);
    notificationTimeoutId = setTimeout(() => {
      var data = { isVisible: false, message: '', statusCode: 2 };
      commit("updateData", data);
    }, 4000);
  }
};

const mutations = {
  updateData(state, data) {
    Object.keys(data).forEach(key => {
      Object.assign(state.toastNotification, { [key]: data[key] });
    });

    setState(LocalStoreConstants.toastNotification, state.toastNotification);
  },
  [SET_TOAST_NOTIFICATION](state, value) {
    state.toastNotification = value;
    setState(LocalStoreConstants.toastNotification, state.toastNotification);
  },
  [SET_TOAST_NOTIFICATION_FIELD](state, data) {
    Object.assign(state.toastNotification, { [data.key]: data.value });
    setState(LocalStoreConstants.toastNotification, state.toastNotification);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
